export default __webpack_public_path__ + "static/media/Privacy-Policy.2e6ff37f.jpg";